// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ********************************************************************* foods **********************************************************************
const INDEX_FEED_FOODS_SUCCESS = "INDEX_FEED_FOODS_SUCCESS";
const SHOW_FEED_FOOD_SUCCESS = "SHOW_FEED_FOOD_SUCCESS";
const STORE_FEED_FOOD_SUCCESS = "STORE_FEED_FOOD_SUCCESS";
const UPDATE_FEED_FOOD_SUCCESS = "UPDATE_FEED_FOOD_SUCCESS";
const DESTROY_FEED_FOOD_SUCCESS = "DESTROY_FEED_FOOD_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ********************************************************************* foods **********************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSuccess(payload) {
  return {
    type: INDEX_FEED_FOODS_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccess(payload) {
  return {
    type: SHOW_FEED_FOOD_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_FEED_FOOD_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateSuccess(payload) {
  return {
    type: UPDATE_FEED_FOOD_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroySuccess(payload) {
  return {
    type: DESTROY_FEED_FOOD_SUCCESS,
    payload: payload,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ********************************************************************* foods **********************************************************************

/**
 *
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Food@index") || app.can("Reserve@index")) {
      api
        .get("/feeding/foods", { params })
        .then((res) => {
          dispatch(_indexSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.feed",
            "Food",
            app.translate("routes.home.feed.Indexing Foods Failed")
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.Food",
              "Food"
            )} - ${app.translate(
              "routes.home.basic.permission.index",
              "index"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyFoods() {
  return _indexSuccess({ data: { foods: [] }, meta: {} });
}

/**
 *
 * @param {Number} food
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function show(food, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Food@index")) {
      api
        .get(`/feeding/foods/${food}`, { params })
        .then((res) => {
          dispatch(_showSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.feed",
            "Food",
            app.translate("routes.home.feed.Indexing Food Failed")
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.Food",
              "Food"
            )} - ${app.translate(
              "routes.home.basic.permission.index",
              "index"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyFood() {
  return _showSuccess({ data: { food: {} }, meta: {} });
}

/**
 *
 * @param {Object} data
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Food@store")) {
      let loader = app.loading(
        app.translate("routes.home.feed.Adding New Food")
      );

      api
        .post("/feeding/foods", { data: { food: data }, params })
        .then((res) => {
          dispatch(_storeSuccess(res));
          loader.hide(() =>
            app.message(
              app.translate("routes.home.feed.New Food Added Successfully")
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed",
              "Food",
              app.translate("routes.home.feed.Adding New Food Failed")
            )
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.Food",
              "Food"
            )} - ${app.translate(
              "routes.home.basic.permission.store",
              "store"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

/**
 *
 * @param {Number} food
 * @param {Object} data
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function update(food, data, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Food@update")) {
      let loader = app.loading(app.translate("routes.home.feed.Updating Food"));

      api
        .put(`/feeding/foods/${food}`, { data: { food: data }, params })
        .then((res) => {
          dispatch(_updateSuccess(res));
          loader.hide(() =>
            app.message(
              app.translate("routes.home.feed.Food Updated Successfully")
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed",
              "Food",
              app.translate("routes.home.feed.Updating Food Failed")
            )
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.Food",
              "Food"
            )} - ${app.translate(
              "routes.home.basic.permission.update",
              "update"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

/**
 *
 * @param {Number} food
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroy(food, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Food@destroy")) {
      let loader = app.loading(app.translate("routes.home.feed.Removing Food"));

      api
        .delete(`/feeding/foods/${food}`, { params })
        .then((res) => {
          console.log("res.code", res.code);
          if (res.code < 0) {
            loader.hide(() =>
              app.error(
                err,
                "routes.home.feed",
                "در وعده غذایی استفاده شده است!",
                app.translate("routes.home.feed.Removing Food Failed")
              )
            );
            console.log("delertedres.coderes.code");
          } else {
            console.log("successres.coderes.code");
            dispatch(_destroySuccess(food));
            loader.hide(() =>
              app.message(
                app.translate("routes.home.feed.Food Removed Successfully")
              )
            );
            callback(undefined, res);
          }
        })
        .catch((err) => {
          console.log("omadi inja");

          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed",
              "در وعده غذایی استفاده شده است!",
              app.translate("routes.home.feed.Removing Food Failed")
            )
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.Food",
              "Food"
            )} - ${app.translate(
              "routes.home.basic.permission.destroy",
              "destroy"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    foods: [],
    food: {},
    meta: {},
  },
  action
) {
  let foods;
  let _index;
  switch (action.type) {
    case INDEX_FEED_FOODS_SUCCESS:
      return Object.assign({}, state, {
        foods: action.payload.data.foods,
        meta: action.payload.meta,
      });
    case SHOW_FEED_FOOD_SUCCESS:
      return Object.assign({}, state, {
        food: action.payload.food,
      });
    case STORE_FEED_FOOD_SUCCESS:
      foods = app._.cloneDeep(state.foods);
      foods.push(action.payload);
      return Object.assign({}, state, {
        foods,
      });
    case UPDATE_FEED_FOOD_SUCCESS:
      foods = app._.cloneDeep(state.foods);
      _index = foods.findIndex((_food) => _food.id === action.payload.id);
      foods[_index] = action.payload;
      return Object.assign({}, state, {
        foods,
      });
    case DESTROY_FEED_FOOD_SUCCESS:
      foods = app._.cloneDeep(state.foods);
      _index = foods.findIndex((_food) => _food.id === action.payload);
      foods.splice(_index, 1);
      return Object.assign({}, state, {
        foods,
      });
    default:
      return state;
  }
}
